import * as React from 'react';
import { flow, map, get, forEach } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Form} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, ICustomer, IProduct, IVehicle, QuoteStatus} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import * as moment from 'moment';
import {displayCurrency, getAvailableQuote, getReferralsAndDeclines} from '../../../../util/helpers';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import * as api from '../../../../data/api/api';

interface IQuoteFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  endDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  voluntaryExcess: number;
  compulsoryExcess?: number;
  personalCustomer: boolean;
  insured: ICustomer;
  vehicles: IVehicle[];
  vehicleCount: number;
}

class QuoteForm extends React.Component<IQuoteFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    referred: false,
  };

  public componentDidMount() {
    const { quote, actions, dispatch, change } = this.props;

    if (quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      actions.quote.saveQuote(true);
    }

    this.checkDeclinesAndReferrals();

    const schemeId = get(quote, 'quotes.standard.annual.scheme.id');
    if (schemeId) {
      api.vehicleExcesses(schemeId, quote.application.vehicles)
        .then((result) => {
          forEach (result.meta, (vehicles, type) => {
            forEach (vehicles, (vehicle, index) => {
              dispatch(change('vehicles.' + index + '.excessTheftLockedBuilding',
                vehicle.excess_theft_locked_building));
              dispatch(change('vehicles.' + index + '.excessTheftOther', vehicle.excess_theft_other));
              dispatch(change('vehicles.' + index + '.excessAdft', vehicle.excess_adft));
            });
          });
        });
    }
  }

  public componentWillReceiveProps(nextProps) {
    this.checkDeclinesAndReferrals();
  }

  private checkDeclinesAndReferrals() {
    const { quote, actions } = this.props;

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.referrals !== referralsAndDeclines.referrals) {
      this.setState({referrals: referralsAndDeclines.referrals});
      if (! this.state.referred && !referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({referred: true});
        actions.quote.referralQuote(
          quote.application.id, referralsAndDeclines.referrals,
        );
      }
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
          channel={this.props.channel}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/vehicles'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private renderVehicleExcess = () => {
    const { vehicles } = this.props;

    const excesses = [];
    forEach (vehicles, (vehicle: IVehicle) => {
      if (vehicle.excessTheftLockedBuilding || vehicle.excessTheftOther) {
        excesses.push({
          registration: vehicle.registrationNumber,
          theftLockedBuilding: vehicle.excessTheftLockedBuilding,
          theftOther: vehicle.excessTheftOther,
        });
      }
    });

    if (!excesses.length) {
      return <div />;
    }

    return (
      <div>
        {excesses.map((vehicle, key) => {
          return (
            <div className="premium-row" key={key}>
              <div className="premium-item-title">
                Additional Vehicle Excess {vehicle.registration}
              </div>
              <div className="premium-item">
                Theft £{displayCurrency(vehicle.theftOther, ',', true)} reducing to
                £{displayCurrency(vehicle.theftLockedBuilding, ',', true)} if vehicle is kept in a locked building
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  private renderPremium = () => {
    const { voluntaryExcess, compulsoryExcess, quote } = this.props;

    const availableQuote = getAvailableQuote(quote);

    return (
      <div className="sub-content-container-alt">
        <div className="premium-body">
          <div className="premium-icon visible-xs-block hidden-xs">
            <img src={require('../../img/tick_list_white.svg')} alt="" />
          </div>
          <div className="premium-content">
            <div className="premium-row-title">
              <div className="premium-item-title">
                Total Premium
              </div>
              <div className="premium-result-title">
                £{displayCurrency(availableQuote[0].gross, ',')}
                <span>{'   '}Inc IPT {availableQuote[0].taxRate}%</span>
              </div>
            </div>
            <div className="premium-row">
              <div className="premium-item-title">
                Compulsory Policy Excess
              </div>
              <div className="premium-item">
                £{displayCurrency(compulsoryExcess ? compulsoryExcess : 100, ',', true)} Accidental Damage Fire & Theft
              </div>
            </div>
            {this.renderVehicleExcess()}
            <div className="premium-row">
              <div className="premium-item-title">
                Voluntary Excess
              </div>
              <div className="premium-item">
                £{displayCurrency(voluntaryExcess, ',', true)} Accidental Damage Fire & Theft
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private renderCoverInformation = () => {
    const { personalCustomer, insured, startDate, endDate, vehicles } = this.props;

    if (!insured) {
      return <div />;
    }

    const renderVehicles = map(vehicles, (vehicle: IVehicle, key: number) => {
      return (
        <div key={key}>
          <div className="cover-information-row no-border">
            {vehicle.registrationNumber}
          </div>
          <div className="cover-information-row no-border">
            Vehicle Make:
            <span className="cover-information-detail">{vehicle.make}</span>
          </div>
          <div className="cover-information-row no-border">
            Vehicle Model:
            <span className="cover-information-detail">{vehicle.model}</span>
          </div>
          <div className="cover-information-row no-border">
            Year of Make:
            <span className="cover-information-detail">{vehicle.year}</span>
          </div>
          <div className="cover-information-row no-border">
            Body Type:
            <span className="cover-information-detail">{vehicle.bodyType}</span>
          </div>
          <div className="cover-information-row no-border">
            Value:
            <span className="cover-information-detail">£{displayCurrency(vehicle.value, ',')}</span>
          </div>
          <div className="cover-information-row">
            Cover:
            <span className="cover-information-detail">{vehicle.coverType}</span>
          </div>
        </div>
      );
    });

    return (
      <div className="sub-content-container-alt">
        {personalCustomer ? (
          <div>
            <div className="cover-information-row height-cover-dates-mobile">
              Cover Dates:
              <span className="cover-information-detail">{startDate} to {moment(endDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className="cover-information-row">
              Proposer Name:
              <span className="cover-information-detail">{insured.title} {insured.firstName} {insured.lastName}</span>
            </div>
            <div className="cover-information-row">
              Proposer Date of Birth:
              <span className="cover-information-detail">{insured.dob}</span>
            </div>
            <div className="cover-information-row height-email-address-mobile">
              Email Address:
              <span className="cover-information-detail">{insured.email}</span>
            </div>
            <div className="cover-information-row height-cover-dates-mobile">
              Phone Number:
              <span className="cover-information-detail">{insured.phone1}</span>
            </div>
            <div className="cover-information-row">
              Proposer Correspondence Address:
              <span className="cover-information-detail">{insured.address.line1}</span><br />
              {insured.address.line2 && insured.address.line2 !== '' && (
                <><span className="cover-information-detail">{insured.address.line2}</span><br /></>
              )}
              <span className="cover-information-detail">{insured.address.town}</span><br />
              <span className="cover-information-detail">{insured.address.county}</span><br />
              <span className="cover-information-detail">{insured.address.postcode}</span><br />
            </div>
          </div>
        ) : (
          <div>
            <div className="cover-information-row height-cover-dates-mobile">
              Cover Dates:
              <span className="cover-information-detail">{startDate} to {moment(endDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className="cover-information-row">
              Company Name:
              <span className="cover-information-detail">{insured.companyName}</span>
            </div>
            <div className="cover-information-row">
              Trading Name:
              <span className="cover-information-detail">{insured.metadata.tradingName}</span>
            </div>
            <div className="cover-information-row">
              Company Registration Number:
              <span className="cover-information-detail">{insured.metadata.companyRegistrationNumber}</span>
            </div>
            <div className="cover-information-row height-email-address-mobile">
              Email Address:
              <span className="cover-information-detail">{insured.email}</span>
            </div>
            <div className="cover-information-row height-cover-dates-mobile">
              Phone Number:
              <span className="cover-information-detail">{insured.phone1}</span>
            </div>
            <div className="cover-information-row">
              Year Company Established:
              <span className="cover-information-detail">{insured.metadata.year}</span>
            </div>
            <div className="cover-information-row">
              Company Correspondence Address:
              <span className="cover-information-detail">{insured.address.line1}</span><br />
              {insured.address.line2 && insured.address.line2 !== '' && (
                <><span className="cover-information-detail">{insured.address.line2}</span><br /></>
              )}
              <span className="cover-information-detail">{insured.address.town}</span><br />
              <span className="cover-information-detail">{insured.address.county}</span><br />
              <span className="cover-information-detail">{insured.address.postcode}</span><br />
            </div>
          </div>
        )}
        {renderVehicles}
      </div>
    );
  }

  public render() {
    const { handleSubmit, quote } = this.props;
    const { declines, referrals, referred } = this.state;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declines.length > 0 || referrals.length > 0 || referred || declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const hasBackButton = quote.application.status !== QuoteStatus.REFERRAL_APPROVED;

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            {this.renderPremium()}
          </div>

          <div className="sub-content-container-alt">
            <h3>Cover Information</h3>
            {this.renderCoverInformation()}
          </div>
          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/vehicles'}
            {...this.props}
            nextButtonDisabled={false}
            hasSaveButton={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const voluntaryExcess = selector(state, 'voluntaryExcess');
      const personalCustomer = selector(state, 'personalCustomer');
      const insured = selector(state, 'insured');
      const vehicles = selector(state, 'vehicles');
      const vehicleCount = selector(state, 'vehicleCount');
      const compulsoryExcess = selector(state, 'compulsoryExcess');

      return {
        startDate,
        endDate,
        quotationTypes,
        voluntaryExcess,
        personalCustomer,
        insured,
        vehicles,
        vehicleCount,
        compulsoryExcess,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(QuoteForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Quote/index.tsx